import { render, staticRenderFns } from "./friendRecall.vue?vue&type=template&id=414c49ea&scoped=true&"
import script from "./friendRecall.vue?vue&type=script&lang=js&"
export * from "./friendRecall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414c49ea",
  null
  
)

export default component.exports